export const PIXEL_SIZE = 10;
export const DEFAULT_SCALE = 1;
export const DEFAULT_CANVAS_WIDTH = 250;
export const DEFAULT_CANVAS_HEIGHT = 200;
export const colors = [
  "black",
  "white",
  "dimgray",
  "sienna",
  "tan",
  "navy",
  "cornflowerblue",
  "teal",
  "darkolivegreen",
  "mediumseagreen",
  "purple",
  "plum",
  "gold",
  "darkorange",
  "orangered",
  "firebrick",
] as const;
